export default "__VITE_ASSET__BldollDi__"